module.exports = __webpack_public_path__ + "6019ae3c030345b7f3c1cad38dbc15ad.png";